import { isEmpty } from 'lodash';
import { NativeModules, Platform } from "react-native";
import fecha from 'fecha';
import {
  bookingDetails,
  railPricingDetails,
  railSearchContext,
  travellerDetailsList
} from '../PdtModel/RailsPdtTemplate';
import {diffDays, now} from '@mmt/legacy-commons/Helpers/dateHelpers';
import RailsConfig from '../../RailsConfig';
import { getDeviceDetails } from '@mmt/legacy-commons/Helpers/genericHelper';
import _isEmpty from 'lodash/isEmpty';
import { ProfileType } from '@mmt/legacy-commons/Native/UserSession/UserSessionModule';
import { getAppLaunchSource, getNativeUserDetails } from "../../Utils/CommonUtils";
import { trackPdtLandingLoad } from "../../pages/RailsLandingPage/Store/RailsLandingPageActions";
import fetch2 from '../../fetch2';
export const isRawClient = () => Platform.OS === 'web';
export const RAIL_SEARCH_CONTEXT_DATA_TYPE = 'rail_search_context';
export const RAIL_LISTING_PAGE_DATA_TYPE = 'train_list';
export const RAIL_AVAILABILITY_CARD_DATA_TYPE = 'train_avl_clicked_details';
let encryptedUserDetails= null;
let commonHeadersObj = null;
export const trackPdtAfterInitRailsLanding = (railsLanding) => {
  const searchContextData = getCommonSearchContextData(railsLanding);
  const originStation = railsLanding?.originStation;
  const destinationStation = railsLanding?.destinationStation;
  const departureDate = railsLanding?.departureDate;
  const pdtData = {
    searchContextData : {
      searchContext: {
        frmStnName: originStation?.cityName,
        frmStnCode: originStation?.code,
        toStnName: destinationStation?.cityName,
        toStnCode: destinationStation?.code,
        journeyDate: departureDate,
      },
      ...searchContextData
    }
  };
  trackPdtLandingLoad(pdtData);
}
export const getCommonSearchContextData = (railsLanding) => {
  const {LocusDetails} = railsLanding;
  const {fromLocusCode , toLocusCode , fromLobCode , toLobCode , fromStationName,
    toStationName , sourceLocusType , destinationLocusType
  } = LocusDetails;
  return {
    fromLocusCode , toLocusCode , fromLobCode , toLobCode , fromStationName,
    toStationName , sourceLocusType , destinationLocusType
  }
}
export const getSearchEventData = (searchData) => {
  if (isEmpty(searchData)) {
    return null;
  }
  const {
    fromLocusCode , toLocusCode , fromLobCode , toLobCode , fromStationName,
    toStationName , sourceLocusType , destinationLocusType
  } = searchData;
  let pdtData = {
    source_locus_code : fromLocusCode,
    source_locus_type : sourceLocusType,
    source_locus_city_code : fromLocusCode,
    source_locus_station_code : fromLobCode,
    source_locus_station_name : fromStationName,
    destination_locus_code : toLocusCode,
    destination_locus_type : destinationLocusType,
    destination_locus_city_code : toLocusCode,
    destination_locus_station_code : toLobCode,
    destination_locus_station_name : toStationName
  };
  if(searchData.searchContext){
    const { searchContext: { frmStnName, frmStnCode, toStnName, toStnCode, journeyDate }} = searchData;
    pdtData = {
      ...pdtData,
      from_station_name: frmStnName,
      to_station_name: toStnName,
      from_station_cd: frmStnCode,
      to_station_cd: toStnCode,
      journey_date: journeyDate && fecha.format(journeyDate, 'YYYY-MM-DD')
    }
    return railSearchContext(pdtData);
  }

  const {
    selectedTrainInfo, selectedBookingDate: {availablityStatus, availablityType},
    selectedClassType, selectedQuota: {code}, totalCollectibleAmount
  } = searchData;
  const {
    frmStnName, frmStnCode, toStnName, toStnCode, duration, arrivalDateAndTime,
    departureDateAndTime, trainName, trainNumber
  } = selectedTrainInfo;
  const advancePurchase = diffDays(new Date(departureDateAndTime), now());
  const boardingStation = selectedTrainInfo?.boardingStation;
  const boardingStationCode = boardingStation?.code || frmStnCode;
  const boardingStationName = boardingStation?.code || frmStnName;
  pdtData = {
    ...pdtData,
    from_city_name: frmStnName,
    to_city_name: toStnName,
    advance_purchase: advancePurchase !== null && advancePurchase !== undefined ? String(advancePurchase) : '0',
    duration,
    arrival_time: new Date(arrivalDateAndTime).getTime(),
    departure_time: new Date(departureDateAndTime).getTime(),
    from_station_cd: frmStnCode,
    from_city_cd: frmStnCode,
    to_station_cd: toStnCode,
    to_city_cd: toStnCode,
    journey_date: fecha.format(new Date(departureDateAndTime), 'YYYY-MM-DD'),
    journey_class: selectedClassType,
    train_name: trainName,
    train_number: trainNumber,
    quota: code,
    price: totalCollectibleAmount,
    availability: availablityStatus,
    availabilityType: availablityType,
    from_station_name: frmStnName,
    to_station_name: toStnName,
    boarding_station_cd: boardingStationCode,
    boarding_station_name: boardingStationName,
    boarding_time: new Date(departureDateAndTime).getTime(),
  };
  return railSearchContext(pdtData);
};
export const getRailPricingDetails = (priceData) => {
  if (isEmpty(priceData)) {
    return null;
  }
  return railPricingDetails(priceData);
};
export const getTrainListData = (trainList) => {
  const train_list = [];
  let train_tickets_count = {
    total_tickets_count : 0,
    total_avl_tickets : 0,
    total_confirmation_guaranteed_tickets_count : 0,
    total_WL_tickets : 0,
    total_RAC_tickets : 0,
    total_tap_to_update_tickets : 0,
    total_FC_ticket_count : 0,
    total_unavailable_tickets : 0
  }
  if (typeof trainList === 'object' && trainList !== null) {
    return [null, train_tickets_count];
  }
  trainList.forEach((item) => {
    let trainPdtData = {
      train: {
        name: item.trainName,
        number: item.trainNumber,
        is_cluster: item.clusterTrain,
        duration: item.duration
      },
      from_station: {
        code: item.frmStnCode,
        name: item.frmStnName,
        departure_time: item.departureTime,
        departure_date: ''
      },
      to_station: {
        code: item.toStnCode,
        name: item.toStnName,
        arrival_time: item.arrivalTime,
        arrival_date: '',
      },
      availability_details: item.tbsAvailability.map((data) => {
        let free_cancellation_available = false;
        let confirmation_guarantee = false;
        let confirmation_probablity = null;
        if(!isEmpty(data.confirmationGuaranteeText)) {
          confirmation_guarantee = true;
        }
        if(!isEmpty(data.freeCancellationText)) {
          free_cancellation_available = true;
        }
        if(data.predictionPercentage) confirmation_probablity = data.predictionPercentage;
        if(!data.availablityStatus) ++train_tickets_count.total_tap_to_update_tickets;
        if(data.availablityType === "1") ++train_tickets_count.total_avl_tickets;
        if(data.availablityType === "2") ++train_tickets_count.total_RAC_tickets;
        if(data.availablityType === "3") ++train_tickets_count.total_WL_tickets;
        if(confirmation_guarantee) ++train_tickets_count.total_confirmation_guaranteed_tickets_count;
        if(free_cancellation_available) ++train_tickets_count.total_FC_ticket_count;
        ++train_tickets_count.total_tickets_count;
        return {
          status: data.availablityStatus,
          class_name: data.className,
          quota: data.quota,
          fare: data.totalFare,
          availability_last_updated: data.lastUpdatedOn,
          free_cancellation_available : free_cancellation_available,
          Trip_gaurantee_available : confirmation_guarantee,
          confirmation_probability_val : confirmation_probablity,
          confirmation_probability_shown : !isEmpty(confirmation_probablity),
        };
      })
    };
    train_list.push(trainPdtData);
  });
  train_tickets_count.total_unavailable_tickets = train_tickets_count.total_tickets_count -
    (train_tickets_count.total_avl_tickets + train_tickets_count.total_WL_tickets + train_tickets_count.total_RAC_tickets + train_tickets_count.total_tap_to_update_tickets);
  return [train_list,train_tickets_count];
};

export const getAvailabilityCardClickedData = (item, selectedClass) => {
  const selectedTbsCard =
    item.tbsAvailability.find(
      (element) => ( (element.className === selectedClass.selectedClassType) && (element.quota === selectedClass.selectedQuota)
      ));
  let trainPdtData = {
    train: {
      name: item.trainName,
      number: item.trainNumber,
      is_cluster: item.clusterTrain,
      duration: item.duration
    },
    from_station: {
      code: item.frmStnCode,
      name: item.frmStnName,
      departure_time: item.departureTime,
      departure_date: item.departureDateAndTime,
    },
    to_station: {
      code: item.toStnCode,
      name: item.toStnName,
      arrival_time: item.arrivalTime,
      arrival_date: item.arrivalDateAndTime,
    },
    availability_details: {
      status: selectedTbsCard?.availablityStatus,
      class_name: selectedTbsCard?.className,
      quota: selectedTbsCard?.quota,
      fare: selectedTbsCard?.totalFare,
      availability_last_updated: selectedTbsCard?.lastUpdatedOn,
      confirmation_probability_val: selectedTbsCard?.predictionPercentage,
      confirmation_probability_shown: !isEmpty(selectedTbsCard?.predictionPercentage)
    }
  }
  return trainPdtData;
};
export const getTravellerDetailsList = (travellerData) => {
  if (isEmpty(travellerData)) {
    return [null,null];
  }
  const {
    email,
    mobile,
    name,
    confirmation_gurantee_available,
    zero_cancellation_available,
    confirmation_gurantee_opted,
    zero_cancellation_opted,
    confirmation_premium_variant,
    confirmation_gurantee_premium_amount,
    zero_cancellation_premium_amount,
    confirmation_probablity
  } = travellerData;
  const pdtData = {
    mobile_communication_id: mobile,
    email_communication_id: email,
    mobile_country_code: '91',
    first_name: name,
    confirmation_gurantee_available,
    zero_cancellation_available,
    confirmation_gurantee_opted,
    zero_cancellation_opted,
    confirmation_premium_variant,
    confirmation_gurantee_premium_amount,
    zero_cancellation_premium_amount,
    confirmation_probablity
  };
  return travellerDetailsList(pdtData);
};
export const getBookingDetails = (bookingData) => {
  if (isEmpty(bookingData)) {
    return null;
  }
  const {
    mmtId,
      totalAmount,
    bookingStatus,
    confirmation_gurantee_available = null,
    zero_cancellation_available = null,
    confirmation_gurantee_opted = null,
    zero_cancellation_opted = null,
    confirmation_premium_variant = null,
    confirmation_gurantee_premium_amount = null,
    zero_cancellation_premium_amount = null,
    confirmation_probablity = null
  } = bookingData;
  const pdtData = {
    booking_created_timestamp: now().getTime(),
    booking_transaction_id: mmtId,
    booking_confirmation_status: bookingStatus,
    total_amount: parseFloat(totalAmount) || null,
    confirmation_gurantee_available,
    zero_cancellation_available,
    confirmation_gurantee_opted,
    zero_cancellation_opted,
    confirmation_premium_variant,
    confirmation_gurantee_premium_amount,
    zero_cancellation_premium_amount,
    confirmation_probablity
  };
  return bookingDetails(pdtData);
};
export const getComIds = async (email = '', mobile = '') => {
  const request = {
    commIdList:[
      {
        value: email,
        type: "F",
        action: "ENCODE"
      },
      {
        value: mobile,
        type: "N",
        valueCode: 91,
        action: "ENCODE"
      }
    ]
  };
  const DEFAULT_HEADERS = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  };
  try {
    const resp = await fetch2(RailsConfig.getEncodedCommIdURL, {
      method: 'POST',
      body: JSON.stringify(request),
      headers:DEFAULT_HEADERS
    });
    let response = await resp.json();
    response = response.commIdList;
    return {
      eComId: response[0].result,
      mComId: response[1].result
    };
  } catch (e) {
    return {
      eComId: '',
      mComId: ''
    }
  }
};
export const getEncryptedUserDetails = async (userData) =>{
  //let tempData = {...userData};
  if(isEmpty(userData)){
    return userData;
  }
  else if(!isEmpty(encryptedUserDetails)){
    return encryptedUserDetails;
  }
  let temp = {...userData};
  const {eComId = '', mComId=''} = await getComIds(temp.email, temp.mobile?.mobileNumber);
  temp.email = eComId;
  temp.mobile? temp.mobile.mobileNumber = mComId : null;
  //userData = {...userData,...temp}
  encryptedUserDetails = {...userData, ...temp}
  return encryptedUserDetails;
}
export const getCommonHeaders = async () => {
  if (commonHeadersObj) {
    return commonHeadersObj;
  }
  const {NetworkModule} = NativeModules;
  const commonHeaders = await NetworkModule.getHeaders();
  commonHeadersObj = {
    mcId: Platform.OS === 'ios' ? commonHeaders['usr-mcid'] : commonHeaders.mcid
  };
  return commonHeadersObj;
};
export const getCommonPdtData = async () => {
  let userDetails = await getNativeUserDetails();
  userDetails = await getEncryptedUserDetails(userDetails);
  const deviceDetails = await getDeviceDetails();
  if(!_isEmpty(deviceDetails)) {
    let flavour = null;
    if(Platform.OS === 'web') {
      flavour = 'pwa';
    } else if(Platform.OS === 'android') {
      flavour = 'android';
    } else if(Platform.OS === 'ios') {
      flavour = 'ios';
    }
    deviceDetails.flavour = flavour;
    deviceDetails.trafficSource = await getAppLaunchSource();
  }
  const commonHeaders = await getCommonHeaders();
  if(commonHeaders && commonHeaders.mcId) {
    if (!_isEmpty(userDetails)) {
      userDetails.marketing_cloud_id = commonHeaders.mcId;
    } else {
      userDetails = {
        marketing_cloud_id : commonHeaders.mcId,
        profileType : ProfileType.PERSONAL
      }
    }
  }
  return {
    userDetails,
    deviceDetails
  }
}

export const isLocusEmpty = (locusDetails) => {
  return (
    !locusDetails ||
    isEmpty(locusDetails) ||
    Object.values(locusDetails).some((locusFeild) => !locusFeild)
  );
};
